export default __webpack_public_path__ + "static/34-2a4467edc3cfc09122351509aaa9b27e.gif";